import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Switch, Checkbox, Button } from "antd";
import PropTypes from "prop-types";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";

const Container = styled.div`
  // position: relative;
  // height: calc(100vh - 450px);
  .styled-table {
    width: 100%;
    border-collapse: collapse;
  }
  .styled-table th,
  .styled-table td {
    border: 1px solid #e6e6e6;
    padding: 8px;
    text-align: left;
  }

  .styled-table th {
    background-color: #f4f4f4;
    font-weight: bold;
  }

  .styled-table tbody tr:nth-of-type(odd) {
    background-color: #f9f9f9;
  }

  .group-row td {
    background: #fafbfd !important;
    font-weight: 600;
    font-size: 14px;
    color: #222;
  }

  .all-checkbox {
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: 6px;
    color: #444;
  }

  /* Switch style */
  .ant-switch {
    min-width: 34px;
    height: 18px;
    border-radius: 12px !important;
  }
  .ant-switch-handle {
    width: 14px;
    height: 14px;
  }
  .ant-switch-checked {
    background-color: #03c83e !important;
  }
  .ant-switch:not(.ant-switch-checked) {
    background-color: #d9d9d9 !important;
  }

  width: 100%;
  font-family: Inter, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  color: #222;
  .note {
    font-size: 13px;
    color: #666;
    margin-bottom: 12px;
  }
  .card {
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    padding: 18px;
    background: #fff;
  }
  .table-wrap {
    border-radius: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    border: 1px solid #e9ecef;
    background: white;
    -webkit-overflow-scrolling: touch;
  }

  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    min-width: 1000px;
  }

  thead {
    position: sticky;
    top: 0;
    z-index: 3;
    background: #fff;
  }
  thead th {
    padding: 14px 16px;
    border-bottom: 1px solid #eef1f3;
    font-weight: 600;
    font-size: 15px;
    text-align: left;
  }
  thead tr.second-row th {
    background: #fafbfd;
    font-weight: 500;
    font-size: 14px;
  }
  tbody td {
    padding: 14px 16px;
    border-top: 1px solid #f3f4f6;
    font-size: 14px;
    white-space: nowrap;
  }
  tbody tr:nth-of-type(odd) td {
    background: #fafafa;
  }
  .group-row td {
    padding: 10px 18px;
    background: #fff;
    border-top: 0;
    font-weight: 700;
  }
  .group-row-cell {
    display: flex;
    gap: 52px;
    align-items: center;
    width: 100%;
  }
  .group-title-cell {
    width: 260px;
    vertical-align: top;
    font-weight: 600;
    padding: 12px 18px;
  }
  .subtitle-cell {
    width: 260px;
  }
  .center {
    text-align: center;
  }
  .all-checkbox {
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-left: 6px;
  }
  .compact-list {
    margin-top: 14px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #f0f2f5;
  }
  .compact-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-top: 1px solid #f3f4f6;
    background: #fff;
    cursor: pointer;
  }
  .compact-row:first-of-type {
    border-top: 0;
  }
  .compact-row:hover {
    background: #fafbfd;
  }
  .ant-switch-checked {
    background-color: #03c83e !important;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
  }

  .ant-checkbox-checked::after {
    border: 1px solid #28a745 !important;
  }

  .footer-actions {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
`;

const deepClone = (o) => JSON.parse(JSON.stringify(o));

const RolesAndPermissions = ({
  menuList = [],
  setMenuList,
  saveMenuList,
  MenuList,
  selectedRoleId,
  viewOnly = false,
  paydisabled = false,
  step,
  setStep,
  onFinish,
  loading,
  type = "",
  handleCancel = () => {},
}) => {
  const [local, setLocal] = useState(deepClone(menuList || []));
  const [expandedItems, setExpandedItems] = useState([]);

  useEffect(() => setLocal(deepClone(menuList || [])), [menuList]);

  useEffect(() => {
    const ids = (local || [])
      .filter((i) => i.subMenu && i.subMenu.length > 0 && !!i.permission?.view)
      .map((i) => i.id);
    setExpandedItems(ids);
  }, [local]);

  const emitChange = (updated) => {
    if (typeof setMenuList === "function") {
      try {
        setMenuList(updated);
      } catch {
        try {
          setMenuList(() => updated);
        } catch {}
      }
    }
    if (Array.isArray(MenuList) && typeof saveMenuList === "function") {
      const cloned = deepClone(MenuList);
      if (typeof selectedRoleId === "number")
        cloned[selectedRoleId] = deepClone(updated);
      saveMenuList(cloned);
    }
  };

  const toggleSystem = (systemKey, checked, groupItems = [], systemChecked) => {
    const idsToToggle = (groupItems || []).map((g) => g.id);

    setLocal((prev) => {
      const updated = prev.map((it) => {
        if (!idsToToggle.includes(it.id)) return it;

        const newItem = { ...it };

        if (checked) {
          newItem.access = true;
          newItem.permission = {
            view: true,
            create: true,
            edit: true,
            delete: true,
          };
          newItem.subMenu = (newItem.subMenu || []).map((s) => ({
            ...s,
            permission: {
              view: true,
              create: true,
              edit: true,
              delete: true,
            },
            access: true,
          }));
        } else {
          newItem.access = false;
          newItem.permission = {
            view: false,
            create: false,
            edit: false,
            delete: false,
          };
          newItem.subMenu = (newItem.subMenu || []).map((s) => ({
            ...s,
            permission: {
              view: false,
              create: false,
              edit: false,
              delete: false,
            },
            access: false,
          }));
        }

        return newItem;
      });

      emitChange(updated);
      return updated;
    });

    setExpandedItems((prev) => {
      if (checked) {
        return Array.from(new Set([...prev, ...idsToToggle]));
      }
      return prev.filter((id) => !idsToToggle.includes(id));
    });
  };

  const toggleAllForItem = (
    itemId,
    checked,
    subMenuId = null,
    isSubmenu = false
  ) => {
    setLocal((prev) => {
      const updated = prev.map((item) => {
        if (item.id !== itemId) return item;

        if (isSubmenu) {
          const newSub = (item.subMenu || []).map((s) => {
            if (s.id !== subMenuId) return s;
            return {
              ...s,
              permission: checked
                ? {
                    ...(s.permission || {}),
                    view: true,
                    create: true,
                    edit: true,
                    delete: true,
                  }
                : { create: false, view: false, edit: false, delete: false },
              access: !!checked,
            };
          });

          const parentAccess = newSub.some((s) => s.access);

          return {
            ...item,
            subMenu: newSub,
            access: parentAccess,
          };
        }

        const newPerm = checked
          ? {
              ...(item.permission || {}),
              view: true,
              create: true,
              edit: true,
              delete: true,
            }
          : { create: false, view: false, edit: false, delete: false };
        const newSub = (item.subMenu || []).map((s) => ({
          ...s,
          permission: checked
            ? {
                ...(s.permission || {}),
                view: true,
                create: true,
                edit: true,
                delete: true,
              }
            : { create: false, view: false, edit: false, delete: false },
          access: !!checked,
        }));
        return {
          ...item,
          permission: newPerm,
          subMenu: newSub,
          access: !!checked,
        };
      });

      emitChange(updated);
      return updated;
    });

    const parent = local.find((l) => l.id === itemId);
    if (parent && parent.subMenu && parent.subMenu.length > 0) {
      setExpandedItems((prev) =>
        checked
          ? Array.from(new Set([...prev, itemId]))
          : prev.filter((id) => id !== itemId)
      );
    }
  };

  const updatePermission = (roleId, permissionType, submenuKey) => {
    setLocal((prev) => {
      const updated = prev.map((item) => {
        if (item.id !== roleId) return item;

        if (!submenuKey) {
          const newPerm = { ...(item.permission || {}) };
          if (permissionType === "view") {
            newPerm.view = !newPerm.view;
            if (!newPerm.view) {
              newPerm.create = false;
              newPerm.edit = false;
              newPerm.delete = false;
            }
          } else {
            newPerm[permissionType] = !newPerm[permissionType];
            if (newPerm.create || newPerm.edit || newPerm.delete)
              newPerm.view = true;
          }
          const newSubMenu = (item.subMenu || []).map((s) => {
            if (!newPerm.view)
              return {
                ...s,
                permission: {
                  create: false,
                  view: false,
                  edit: false,
                  delete: false,
                },
                access: false,
              };
            return s;
          });
          const parentAccess = newSubMenu.length
            ? newSubMenu.some((s) => s.access)
            : !!newPerm.view;
          return {
            ...item,
            permission: newPerm,
            subMenu: newSubMenu,
            access: parentAccess,
          };
        }

        const newSubMenu = (item.subMenu || []).map((s) => {
          if (s.key !== submenuKey) return s;
          const newPerm = { ...(s.permission || {}) };
          if (permissionType === "view") {
            newPerm.view = !newPerm.view;
            if (!newPerm.view) {
              newPerm.create = false;
              newPerm.edit = false;
              newPerm.delete = false;
            }
          } else {
            newPerm[permissionType] = !newPerm[permissionType];
            if (newPerm.create || newPerm.edit || newPerm.delete)
              newPerm.view = true;
          }
          return {
            ...s,
            permission: newPerm,
            access:
              newPerm.view || newPerm.create || newPerm.edit || newPerm.delete,
          };
        });
        const parentAccess = newSubMenu.some((s) => s.access);
        return { ...item, subMenu: newSubMenu, access: parentAccess };
      });

      emitChange(updated);
      return updated;
    });
  };

  const handleParentViewToggle = (item) => {
    const current = local.find((i) => i.id === item.id)?.permission?.view;
    const newValue = !current;
    updatePermission(item.id, "view");

    if (item.subMenu && item.subMenu.length > 0) {
      setExpandedItems((prev) =>
        newValue
          ? Array.from(new Set([...prev, item.id]))
          : prev.filter((id) => id !== item.id)
      );
    }
  };

  const handleExpandGroup = (groupKey) => {
    setExpandedGroup((prev) =>
      prev.includes(groupKey)
        ? prev.filter((k) => k !== groupKey)
        : [...prev, groupKey]
    );
  };

  const groups = {};
  const order = [];
  local.forEach((item) => {
    const hasSub = item.subMenu && item.subMenu.length > 0;
    const key = hasSub
      ? item.menuName?.trim() || item.title || "Group"
      : "Home";
    if (!groups[key]) {
      groups[key] = [];
      order.push(key);
    }
    groups[key].push(item);
  });
  const orderedKeys = [
    ...new Set(["Home", ...order.filter((k) => k !== "Home")]),
  ];

  const defaultExpandedArray = orderedKeys || [];

  const [expandedGroup, setExpandedGroup] = useState(defaultExpandedArray);

  useEffect(() => {
    const newDefault = orderedKeys.length ? orderedKeys : [];
    setExpandedGroup(newDefault);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuList]);

  const footerStyle = {
    position: "sticky",
    bottom: -25,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };
  return (
    <Container>
      {type === "add" && (
        <div className="note">
          Note: You can specify default permissions when creating a role, and
          these can be customized for individual employees under respective role
          if needed.
        </div>
      )}

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th rowSpan="2" className="">
                  Menu Access Level
                </th>
                <th className=" text-center">Read</th>
                <th colSpan="3" className="text-center">
                  Write
                </th>
              </tr>
              <tr>
                <th className="text-center">View</th>
                <th className="text-center">Create</th>
                <th className="text-center">Modify</th>
                <th className="text-center">Delete</th>
              </tr>
            </thead>

            <tbody>
              {expandedGroup
                .filter((groupKey) => orderedKeys.includes(groupKey))
                .map((groupKey) => {
                  const groupItems = groups[groupKey] || [];
                  const systemKey = groupItems[0]?.system || groupKey;
                  const systemChecked = groupItems.some((g) => g.access);

                  return (
                    <React.Fragment key={groupKey}>
                      <tr className="group-row">
                        <td colSpan={6}>
                          <div className="group-row-cell">
                            <div style={{ fontWeight: 700, width: "120px" }}>
                              {groupKey}
                            </div>

                            <Switch
                              checked={!!systemChecked}
                              disabled={viewOnly}
                              onChange={(checked) =>
                                toggleSystem(
                                  systemKey,
                                  checked,
                                  groupItems,
                                  systemChecked
                                )
                              }
                            />
                          </div>
                        </td>
                      </tr>

                      {systemChecked &&
                        groupItems.map((item) => {
                          if (item.subMenu && item.subMenu.length > 0) {
                            return item.subMenu.map((sub) => (
                              <tr key={`${item.id}-${sub.key}`}>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>{sub?.title}</div>

                                  <div className="all-checkbox">
                                    <Checkbox
                                      checked={
                                        sub?.permission?.view &&
                                        sub?.permission?.create &&
                                        sub?.permission?.edit &&
                                        sub?.permission?.delete
                                      }
                                      disabled={viewOnly}
                                      onChange={(e) =>
                                        toggleAllForItem(
                                          item.id,
                                          e.target.checked,
                                          sub.id,
                                          true
                                        )
                                      }
                                    >
                                      All
                                    </Checkbox>
                                  </div>
                                </td>

                                <td className="center">
                                  <Switch
                                    size="small"
                                    checked={!!sub.permission?.view}
                                    disabled={viewOnly}
                                    onChange={() =>
                                      updatePermission(item.id, "view", sub.key)
                                    }
                                  />
                                </td>

                                <td className="center">
                                  <Switch
                                    size="small"
                                    checked={!!sub.permission?.create}
                                    disabled={viewOnly || !sub.permission?.view}
                                    onChange={() =>
                                      updatePermission(
                                        item.id,
                                        "create",
                                        sub.key
                                      )
                                    }
                                  />
                                </td>

                                <td className="center">
                                  <Switch
                                    size="small"
                                    checked={!!sub.permission?.edit}
                                    disabled={viewOnly || !sub.permission?.view}
                                    onChange={() =>
                                      updatePermission(item.id, "edit", sub.key)
                                    }
                                  />
                                </td>

                                <td className="center">
                                  <Switch
                                    size="small"
                                    checked={!!sub.permission?.delete}
                                    disabled={viewOnly || !sub.permission?.view}
                                    onChange={() =>
                                      updatePermission(
                                        item.id,
                                        "delete",
                                        sub.key
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            ));
                          }

                          return (
                            <tr key={`single-${item.id}`}>
                              <td
                                colSpan={3}
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div>{item.title}</div>
                                {(item?.title === "Dashboard" ||
                                  item?.title === "Calendar" ||
                                  item?.title === "Product Log") && (
                                  <div className="text-start">
                                    {item?.subtitle}
                                  </div>
                                )}

                                <div className="all-checkbox">
                                  <Checkbox
                                    checked={
                                      item?.permission?.view &&
                                      item?.permission?.create &&
                                      item?.permission?.edit &&
                                      item?.permission?.delete
                                    }
                                    disabled={viewOnly}
                                    onChange={(e) =>
                                      toggleAllForItem(
                                        item.id,
                                        e.target.checked
                                      )
                                    }
                                  >
                                    All
                                  </Checkbox>
                                </div>
                              </td>
                              <td className="center">
                                <Switch
                                  size="small"
                                  checked={!!item.permission?.view}
                                  disabled={viewOnly}
                                  onChange={() =>
                                    updatePermission(item.id, "view")
                                  }
                                />
                              </td>

                              <td className="center">
                                <Switch
                                  size="small"
                                  checked={!!item.permission?.create}
                                  disabled={viewOnly || !item.permission?.view}
                                  onChange={() =>
                                    updatePermission(item.id, "create")
                                  }
                                />
                              </td>

                              <td className="center">
                                <Switch
                                  size="small"
                                  checked={!!item.permission?.edit}
                                  disabled={viewOnly || !item.permission?.view}
                                  onChange={() =>
                                    updatePermission(item.id, "edit")
                                  }
                                />
                              </td>

                              <td className="center">
                                <Switch
                                  size="small"
                                  checked={!!item.permission?.delete}
                                  disabled={viewOnly || !item.permission?.view}
                                  onChange={() =>
                                    updatePermission(item.id, "delete")
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                    </React.Fragment>
                  );
                })}
            </tbody>
          </table>
        </div>

        <div className="compact-list" style={{ marginTop: 16 }}>
          {orderedKeys.map((k) => {
            if (expandedGroup.includes(k)) return null;
            const group = groups[k] || [];
            if (group.length === 0) return null;
            const systemKey = group[0]?.system || k;
            const systemChecked = group.some((g) => g.access);

            return (
              <div
                key={`compact-${k}`}
                className="compact-row"
                onClick={() =>
                  setExpandedGroup((prev) =>
                    prev.includes(k)
                      ? prev.filter((x) => x !== k)
                      : [...prev, k]
                  )
                }
              >
                <div style={{ fontWeight: 600 }}>{k}</div>
                <div>
                  <Switch
                    checked={!!systemChecked}
                    disabled={viewOnly}
                    onChange={(checked, event) => {
                      event?.stopPropagation();
                      toggleSystem(systemKey, checked, group, systemChecked);
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {type !== "view" && (
        <div style={footerStyle}>
          <ButtonOutlined onClick={() => handleCancel(false)}>
            Cancel
          </ButtonOutlined>
          {type === "add" && (
            <ButtonOutlined onClick={() => setStep && setStep(step - 1)}>
              Previous
            </ButtonOutlined>
          )}
          <ButtonFilled
            type="primary"
            loading={loading}
            onClick={() => {
              onFinish(local);
            }}
          >
            {type === "add" ? "Create" : "Continue"}
          </ButtonFilled>
        </div>
      )}
    </Container>
  );
};

RolesAndPermissions.propTypes = {
  menuList: PropTypes.array,
  setMenuList: PropTypes.func,
  saveMenuList: PropTypes.func,
  MenuList: PropTypes.array,
  selectedRoleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  viewOnly: PropTypes.bool,
  paydisabled: PropTypes.bool,
  step: PropTypes.number,
  setStep: PropTypes.func,
};

export default RolesAndPermissions;
